import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import { makeStyles, useTheme, Box, Typography } from '@material-ui/core';
import React__default, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import CenterContainer from '../../theme/CenterContainer.js';
import { retrieveContentfulImage } from '../../common/image.js';
import PropTypes__default from 'prop-types';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    stepIndicator: {
      background: theme.palette.primary[100],
      borderRadius: "100%",
      width: theme.spacing(7.5),
      height: theme.spacing(7.5),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "end",
      zIndex: -1
    },
    stepIndicatorEven: _defineProperty({}, theme.breakpoints.up("sm"), {
      position: "absolute",
      top: theme.spacing(14),
      left: -theme.spacing(6)
    }),
    stepIndicatorOdd: _defineProperty({}, theme.breakpoints.up("sm"), {
      position: "absolute",
      top: theme.spacing(14),
      right: -theme.spacing(6)
    }),
    item: {
      position: "relative",
      zIndex: 2
    },
    oddItemWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      textAlign: "right",
      "float": "right",
      width: "45%"
    },
    evenItemWrapper: {
      marginLeft: "55%"
    },
    itemIcon: {
      width: theme.spacing(12),
      height: theme.spacing(11.25)
    },
    description: {
      "& > p": {
        fontWeight: "300"
      }
    }
  };
});
var NumberedSteps = function NumberedSteps(_ref) {
  var bgColor = _ref.bgColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    elements = _ref.elements;
  var classes = useStyles();
  var theme = useTheme();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  var _useState = useState([1, 2, 3]),
    _useState2 = _slicedToArray(_useState, 2),
    stepItems = _useState2[0],
    setStepItems = _useState2[1];
  useEffect(function () {
    if (elements) {
      setStepItems(elements);
    }
  }, [elements]);
  var _StepIndicator = function StepIndicator(_ref2) {
    var index = _ref2.index,
      className = _ref2.className;
    _StepIndicator.propTypes = {
      index: PropTypes__default.number,
      className: PropTypes__default.any
    };
    return /*#__PURE__*/React__default.createElement(Box, {
      className: className
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h3",
      component: "div"
    }, index + 1));
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(CenterContainer, {
    maxWidth: theme.breakpoints.width("lg")
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    px: 2,
    pt: 10,
    pb: 10
  }, /*#__PURE__*/React__default.createElement(Box, {
    textAlign: isExtraSmallScreen() ? "center" : "left"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "overline"
  }, subtitle), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "h2"
  }, title)), /*#__PURE__*/React__default.createElement(Box, {
    mt: 6
  }, stepItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Box, {
      key: index,
      mt: 4,
      width: "100%",
      display: "flex",
      position: "relative"
    }, /*#__PURE__*/React__default.createElement(Box, {
      className: clsx(classes.item, _defineProperty({}, classes.oddItemWrapper, !isExtraSmallScreen() && index % 2 !== 0), _defineProperty({}, classes.evenItemWrapper, !isExtraSmallScreen() && index % 2 === 0))
    }, !isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(_StepIndicator, {
      index: index,
      className: clsx(classes.stepIndicator, _defineProperty({}, classes.stepIndicatorOdd, index % 2 !== 0), _defineProperty({}, classes.stepIndicatorEven, index % 2 === 0))
    }), /*#__PURE__*/React__default.createElement(Box, {
      display: "flex",
      justifyContent: index % 2 !== 0 && !isExtraSmallScreen() ? "flex-end" : "flex-start",
      alignItems: index % 2 !== 0 && !isExtraSmallScreen() ? "flex-end" : "flex-start"
    }, isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(_StepIndicator, {
      index: index,
      className: clsx(classes.stepIndicator, _defineProperty({}, classes.stepIndicatorOdd, index % 2 !== 0), _defineProperty({}, classes.stepIndicatorEven, index % 2 === 0))
    }), /*#__PURE__*/React__default.createElement(Box, {
      ml: isExtraSmallScreen() ? 3 : 0
    }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.itemIcon,
      src: retrieveContentfulImage(item === null || item === void 0 ? void 0 : item.imageUrl, {
        width: 96,
        height: 90
      }),
      alt: (item === null || item === void 0 ? void 0 : item.imageTitle) || ""
    }))), /*#__PURE__*/React__default.createElement(Box, {
      mt: isExtraSmallScreen() ? 2 : 0
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "overline"
    }, item === null || item === void 0 ? void 0 : item.subtitle)), /*#__PURE__*/React__default.createElement(Box, {
      mt: isExtraSmallScreen() ? 2 : 1
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h3",
      component: "h2"
    }, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/React__default.createElement(Typography, {
      component: "div",
      className: classes.description
    }, (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item === null || item === void 0 ? void 0 : item.description
    })))));
  })))));
};
NumberedSteps.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  elements: PropTypes__default.array
};

export { NumberedSteps, NumberedSteps as default };
//# sourceMappingURL=NumberedSteps.js.map
